<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->

    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!--for overlay :loading="get_ay_std_ft_loader" -->
    <!--api- 1  -->
    <v-card v-if="first_load">
      <!-- {{file_upload_config}} -->
      <v-card-text>
        <v-row justify="center">
          <v-col sm="3">
            <h3>Cordinator-Album</h3>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-combobox dense required v-model="current_academic_year" :items="ay_std_data.academic_year_list"
              item-text="Academic Year" label="Academic Year" @change="get_albums" outlined />
          </v-col>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-combobox dense required v-model="std" :items="ay_std_data.standard_list" item-text="Standard"
              label="Standard" outlined />
          </v-col>
          <v-col sm="2" v-if="division_list != null">
            <v-icon color="error">*</v-icon>
            <v-combobox dense required v-model="division" :items="division_list" item-text="divname" label="Division"
              outlined />
          </v-col>
        </v-row>
        <template v-if="send_msg_flag">
          <v-col cols="12">
            <v-text-field label="Title" v-model="title" placeholder="Colleges reopens"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea label="Description" v-model="description" value placeholder="Colleges reopens on...."
              hint="Enter description of notice or home work"></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-file-input v-model="attachments" placeholder="Upload attachment if any" label="Attachment" multiple
              prepend-icon="mdi-paperclip">
              <template v-slot:selection="{ text }">
                <v-chip small label color="primary">{{ text }}</v-chip>
              </template>
            </v-file-input>
          </v-col>
          <v-btn @click="putNoticeHW" :loading="send_btn_load">Send</v-btn>
        </template>
      </v-card-text>
    </v-card>
    <br />

    <div v-if="send_msg_flag">

      <v-data-table :items="album_list" :headers="headers" class="elevation-1" :search="search">
        <template v-slot:top>
          <v-toolbar flat color="white" align="center" justify="center">
            <v-toolbar-title>List of Albums</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:item.edit="{item}">
          <div>
            <v-btn color="secondary" icon dark @click="editDialog(item)" title="Edit Album">
              <!-- <v-icon left>mdi-email-send-outline</v-icon> -->
              <v-icon>mdi-file-document-edit</v-icon>
            </v-btn>
          </div>
        </template>
        <template v-slot:item.delete="{item}">
          <div>
            <v-btn color="warning" icon dark :loading="delete_btn_load" @click="deleteAlbum(item)" title="delete album">
              <!-- <v-icon left>mdi-email-send-outline</v-icon> -->
              <v-icon>mdi-delete-empty</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </div>

    <!-- api-1 ends -->
    <!-- api-3 -->
    <v-dialog v-model="edit_dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field dense hint="cannot edit" disabled v-model="editedItem.date"
                  label="Sent Date"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field dense hint="cannot edit" disabled v-model="editedItem.from" label="From"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field dense hint="cannot edit" disabled v-model="editedItem.to" label="To"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field dense hint="editable" v-model="editedItem.title" label="Title"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea label="Description" v-model="editedItem.description" dense
                  placeholder="Colleges reopens on...." hint="editable"></v-textarea>
              </v-col>
            </v-row>
            <v-col cols="12">
              <v-file-input v-model="edit_attachments" placeholder="Upload attachment if any" label="Attachment"
                multiple prepend-icon="mdi-paperclip">
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">{{ text }}</v-chip>
                </template>
              </v-file-input>
            </v-col>
            <template v-if="editedItem.attachment_list.length>0">
              <h3>Attachments</h3>
              <ol>
                <li v-for="attach in editedItem.attachment_list" :key="attach.attach_id">
                  <a :href="awspath+attach.link">{{attach.attach_name}}</a>
                  <v-btn text title="Delete attachment" :loading="delete_acttach_load"
                    @click="deleteAttachment(attach)"><v-icon color="red">mdi-window-close</v-icon></v-btn>
                </li>
              </ol>
            </template>

          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" :loading="edit_save_attachment_load" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    file_upload_config: { allowed_type: "", max_size: 1000 },
    rules: [
      value =>
        !value || value.size < 2000000 || "Logo size should be less than 2 MB!"
    ],
    first_load:false,
    search: "",
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    ay_std_data: null,
    fetch_btn_load: false,
    std: null,
    current_academic_year: null,
    attachments: [],
    edit_attachments:[],
    title:null,
    description:null,
    division_list: ["All"],
    division: "All",
    fetch_btn_load: false,
    send_btn_load:false,
    album_list_load:false,
    album_list:'',
    delete_btn_load:false,
    send_msg_flag:false,
    delete_acttach_load:false,	
    edit_save_attachment_load:false,
    snackbar_msg: "",
    snackbar: false,
    color: "",
    headers: [
      { text: "Date", value: "date", sortable: true },
      { text: "From", value: "from", sortable: true },
      { text: "To", value: "to", sortable: true },
      { text: "Title", value: "title", sortable: true },
      { text: "Description", value: "description", sortable: true },
      { text: "Edit", value: "edit", sortable: false },
      { text: "Delete", value: "delete", sortable: false },
    ],
    editedItem:{	
	      date:null,	
	      attachment_list:[],	
	      description:null,	
	      from:null,	
	      id:null,	
	      to:null,	
	      title:null,	
	    },	
	    editItemIndex:-1,	
	    edit_dialog:false,	
	    awspath:null,
  }),
  watch: {
    std() {
      this.getDivOff();
    },
    // current_academic_year() {
    //   this.getDivOff();
    // },
    // division(){
    //   this.get_albums();
    // }
    edit_dialog (val) {	
	        val || this.close()	
	      },
  },
  methods: {
    get_albums(){
      this.album_list_load = true
       const formData={
          ay:this.current_academic_year,
          division:this.division,
          std:this.std
       };
       axios
          .post("/communicationType/get_albums_coord", formData)
          .then(res => {
            if (res.data.msg == "200") {
              this.album_list=res.data.album_list
                this.file_upload_config = res.data.file_upload_config;
            this.rules = [
              value =>
                !value ||
                value.size < this.file_upload_config.max_size ||
                "Logo size should be less than " +
                  this.file_upload_config.max_size / 1000000 +
                  "MB!"
            ];
            this.send_msg_flag = true
            }
          })
          .catch(error => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            //close loader
            this.album_list_load = false
          });
    },
    deleteAttachment(attach){	
	      const formData={	
	        attach_id:attach.attach_id	
	      }	
	      this.delete_acttach_load = true	
	      axios	
	        .post("/communicationType/deleteAttachment", formData)	
	        .then(res => {	
	          if (res.data.status == "YES") {	
	            const index = this.editedItem.attachment_list.indexOf(attach)	
	            this.editedItem.attachment_list.splice(index, 1)	
	          }	
	          else{	
              this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
	            //alert(res.data.status_reason)	
	          }	
	        })	
	        .catch(error => {	
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
	          window.console.log(error);	
	        })	
	        .finally(() => {	
	          //close loader	
	          this.delete_acttach_load = false	
	        });	
      },
      close () {	
	        this.edit_dialog = false	
        },
        editDialog(item){	
	      this.awspath =  localStorage.getItem("awspath")	
	      this.editedItem = item	
	      this.edit_dialog = true	
	      this.editItemIndex = this.album_list.indexOf(item)	
	      //alert(this.editItemIndex)	
      },
       save () {	
	      this.edit_save_attachment_load=true	
	     let formData = new FormData();	
	      for (var i = 0; i < this.edit_attachments.length; i++) {	
	        let file = this.edit_attachments[i];	
		
	        formData.append("files", file);	
	      }	
	      formData.append("title", this.editedItem.title);	
	      formData.append("description", this.editedItem.description);	
	      formData.append("comm_id", this.editedItem.id);	
	       axios	
	        .post("/communicationType/saveEditCommunication", formData)	
	        .then(res => {	
	          if (res.data.status == "SUCCESS") {	
              //Object.assign(this.album_list[this.editItemIndex], this.editedItem)
              this.showSnackbar("#4caf50", "Album updated successfully..."); // show snackbar on success
	            //this.get_albums()	
	          }	
	          else{	
              this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
	            //alert(res.data.status_reason)	
	          }	
	        })	
	        .catch(error => {	
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
	          window.console.log(error);	
	        })	
	        .finally(() => {	
	          //close loader	
	          this.edit_save_attachment_load=false	
	          this.edit_attachments=[]	
	         this.close()	
	        });	 	
      },
      deleteAlbum(item){	
	      this.delete_btn_load=true	
	      //alert(item.id)	
	      if(!confirm('Are you sure you want to delete this item?'))	
	          return	
	      const formData={	
	        comm_id:item.id	
	      }	
	      axios	
	        .post("/communicationType/deleteCommunication", formData)	
	        .then(res => {	
	          if (res.data.status == "YES") {	
              this.showSnackbar("#4caf50", res.data.status_reason); // show snackbar on success
	            //alert(res.data.status_reason)	
	            const index = this.album_list.indexOf(item)	
	            this.album_list.splice(index, 1)	
	            //this.get_notices()	
	          }	
	          else{	
              this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
	            //alert(res.data.status_reason)	
	          }	
	        })	
	        .catch(error => {	
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
	          window.console.log(error);	
	        })	
	        .finally(() => {	
	          //close loader	
	          this.delete_btn_load=false	
	        });	
	    },
    putNoticeHW(){
      this.send_btn_load=true
        let formData = new FormData();
        for( var i = 0; i < this.attachments.length; i++ ){
            let file = this.attachments[i];

            formData.append('files', file);
        }
        formData.append("ay", this.current_academic_year);
        formData.append("std", this.std);
        if(this.division=="All")	
	        formData.append("div", this.division);	
	      else
        formData.append("div", this.division.id);
        formData.append("title", this.title);
        formData.append("description", this.description);
        formData.append("type", "Album");
        formData.append("event", "");
        formData.append("who", "Coord");
        axios
            .post("/communicationType/put_commn_coord", formData, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
          .then(res => {
            if (res.data.msg == "200") {
              if(res.data.status=="SUCCESS"){
               // alert("Success")
               this.showSnackbar("#4caf50", "Album Added Successfully..."); // show snackbar on success
              }
              else{
                this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
                //alert(res.data.status_reason)
              }
              this.get_albums()
            }
          })
          .catch(error => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            //close loader
            this.send_btn_load=false

          });
   
    },
    getDivOff() {
      //api-2
      //erase for api-3
      this.title=null;	
	      this.description=null;
      // this.records = [];
      // this.header_list = [];
      // this.xls_header = [];
      //ends
      this.division_list = ["All"];
      this.division = "All";
      // this.report_type = null;
      //this.send_msg_flag = false;
      if(this.std=="All")	
      return
      if (this.std != null && this.current_academic_year != null) {
        const formData = {
          std: this.std,
          ay: this.current_academic_year,
          who:"Coord"
        };
        axios
          .post("/commonAPI/get_div_coord", formData)
          .then(res => {
            if (res.data.msg == "200") {
              if (this.division_list.length == 0) {
                alert("No div offered");
                this.division_list = null;
              } else {
                this.division_list = res.data.division_list;
                this.division_list.unshift("All");
                this.division = this.division_list[0];
              }
            } else {
              //error
            }
          })
          .catch(error => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            //close loader
          });
      }
    },
    get_ay_std() {
      //api-1
            const formData={
          who:"Coord"
      }
      axios
        .post("/commonAPI/get_ay_std_coord",formData)
        .then(res => {
          if (res.data.msg == "200") {
            this.ay_std_data = res.data.co_ay_std_data;
            this.ay_std_data.standard_list.unshift("All");
            this.current_academic_year =
              res.data.co_ay_std_data.current_academic_year;
            this.std = this.ay_std_data.standard_list[0];
            this.division = "All"
            this.get_albums()

          } else {
            //error
          }
        })
        .catch(error => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
            this.first_load=true
        });
    },
    showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
  },
  mounted() {
    this.get_ay_std();
  }
};
</script>
<style scoped>
.allot-btn,
.allot-icon,
.info-icon {
  transition: 0.3s;
}
.allot-btn:hover .allot-icon {
  color: white;
}
.allot-btn:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
}

.info-icon:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
  border-radius: 100%;
}
.table-sub-title {
  margin-left: 1%;
  font-weight: 500;
  color: #999;
}
@media print {
  body {
    height: 100%;
    width: 100%;
  }
  .no-display {
    display: none !important;
  }
  .v-data-footer,
  .v-data-footer__select,
  .v-data-footer__pagination {
    display: none !important;
    visibility: hidden !important;
  }
  .v-data-table table,
  .v-data-table__wrapper {
    width: 100% !important;
    display: block !important;
  }

  table,
  th,
  td {
    border-collapse: collapse !important;
    border: 1px solid black !important;
    width: 100%;
    text-align: right !important;
  }
}
</style>
